export default __webpack_public_path__ + "static/media/OPD_CARD_HOSPITAL_1.e9659a5e.png";